import { Button, Center, Stack, Text } from '@mantine/core'
import { Link } from '@remix-run/react'

type NotFountProps = {
  description?: string
  button?: {
    label?: string
    link?: string
  }
}

export const NotFound = (props: NotFountProps) => (
  <Stack align='stretch' justify='center' h={400} w={'100%'}>
    <Center>
      <Text size='xl'>見つかりませんでした</Text>
    </Center>
    {props.description ?? (
      <Center>
        <Text size='lg'>{props.description}</Text>
      </Center>
    )}
    <Center>
      <Button size='md' component={Link} to={props.button?.link ?? '/'}>
        {props.button?.label ?? 'トップへ戻る'}
      </Button>
    </Center>
  </Stack>
)
